<template>
	<div class="prds" >
		<div class="choose" @click="check">
			<div class="circle" v-if="!isShow"></div>
			<i class="el-icon-success green" v-if="isShow"></i>
		</div>
		<div class="text">{{ name }}</div>
		<div class="toSkip"><span @click="toSkip" class="showPage">查看页面</span></div>
	</div>
</template>

<script>
export default {
	props: ['name', 'id', 'value', 'path', 'thumbnails'],
	data() {
		return {};
	},
	components: {},
	computed: {
		pathUrl() {
			return this.path ? 'https://' + this.queryParam.name + this.path : 'https://' + this.queryParam.name;
		},

		isShow() {
			let flag = this.value.some(item => {
				return this.id == item.productTypeId;
			});
			return flag;
		},
		queryParam() {
			return this.$route.query;
		},
	},
	methods: {
		toSkip() {
			window.open(this.pathUrl);
		},
		check() {
			let imgurl = this.thumbnails && this.thumbnails.length ? this.thumbnails[0].url : '';
			let domain = 'https://' + this.queryParam.name;
			let pagePath = this.path
				? 'https://' + this.queryParam.name + this.path
				: 'https://' + this.queryParam.name;
			//domain域名  explain说明 imgPath图片链接 pagePath页面链接地址 productId产品ID productTypeId 产品分类ID title
			this.$emit('check', {
				domain: domain,
				explain: '',
				imgPath: imgurl,
				productTypeId: this.id,
				pagePath: pagePath,
				title: this.name,
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.prds {
	width: 100%;
	background: #ffffff;
	box-shadow: 0px 1px 6px 0px rgba(51, 51, 51, 0.1);
	border-radius: 4px;
	padding: 10px 14px;
	position: relative;

	.choose {
		display: flex;
		justify-content: flex-start;
		cursor: pointer;

		.circle {
			width: 16px;
			height: 16px;
			border: 1px solid #e9e9e9;
			border-radius: 8px;
		}

		.green {
			color: #34d04c;
			font-size: 16px;
		}
	}

	.text {
		font-weight: 400;
		color: #4a4a4a;
		font-size: 14px;
		margin-top: 12px;
		margin-bottom: 15px;
	}

	.toSkip {
		font-weight: 400;
		color: #3da1ff;
		font-size: 14px;
		position: absolute;
		bottom: 5px;
		right: 5px;
	}

	.showPage {
		cursor: pointer;
	}
}
.prds:hover{
	background-color: #EDF5FE  ;
}
</style>
